export default __webpack_public_path__ + "static/media/hero-img.7a3fe94b.jpg";